import { useTranslation } from 'react-i18next'

import { EMPTY_STRING } from '../../../constants/common'
import { NUMBER_SIZE } from '../../../constants/size'
import { InputField } from '../../Input'

import * as styles from './MultiValuedListMoreFilter.module.css'

import SearchIcon from '../../../icons/search.svg'

function MultiValuedListMoreFilter({
  className = styles.MultiValuedListMoreFilter,
  height = NUMBER_SIZE.size40,
  placeholder = 'MultiValuedList.MoreFilterPlaceholderKey',
  value,
  wrapperClassName = styles.wrapper,
  onChange,
  ...inputProps
}) {
  const { t } = useTranslation()

  function handleChange(event) {
    onChange?.(event.target.value)
  }

  function handleClear() {
    onChange?.(EMPTY_STRING)
  }

  return (
    <InputField
      {...inputProps}
      autoFocus
      afterIconProps={{ Icon: SearchIcon }}
      className={className}
      height={height}
      placeholder={t(placeholder)}
      value={value}
      wrapperClassName={wrapperClassName}
      onChange={handleChange}
      onClear={handleClear}
    />
  )
}

export default MultiValuedListMoreFilter
